import { string, object } from 'yup';
import { emailExp } from 'configs/password';

const EditAdminProfileSchema = t =>
  object().shape({
    email: string().trim().matches(emailExp, t('wrongEmailFormat')).required(t('requiredEmail')),
  });

export default EditAdminProfileSchema;
